<template>
  <section v-editable="cms" :class="[name, getClassName]">
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: 'auto 60px auto',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          rows: '10px auto 10px',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__main`]"
        :layout="[
          { size: 1, x: 1, width: 11 },
          { size: 3, x: 1, width: 16 },
          { size: 4, x: 1, width: 14 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.main"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__main-content`"
        />
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__overlay`]"
        :layout="[
          { size: 1, x: 3, width: 8 },
          { size: 3, x: 15, width: 6 },
          { size: 4, x: 14, width: 6 },
        ]"
        :v-if="cms.overlay.length > 0"
      >
        <component
          :is="item.component"
          v-for="item in cms.overlay"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :layout="[
            { size: 0, bound: 246, ratio: [246, 161] },
            { size: 1, bound: 246, ratio: [246, 161] },
            { size: 2, bound: 470, ratio: [470, 315] },
            { size: 3, bound: 470, ratio: [424, 276] },
          ]"
        />
      </grid-item>
    </grid>
  </section>
</template>
<script>
import data from '~/components/organisms/o-article-v2/o-article-v2.data'
export default {
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-wrapper-overlap',
    }
  },
  computed: {
    getClassName() {
      if (this.cms.overlay.length > 0) {
        return this.cms.overlap_position ? this.cms.overlap_position : 'right'
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.m-article-wrapper-overlap {
  padding: var(--spacing-top) 0 var(--spacing-bottom);
  &__overlay {
    z-index: 10;
    background-color: var(--bg-color-overlap);
    padding: var(--spacing-top-overlap) var(--spacing-right-overlap)
      var(--spacing-bottom-overlap) var(--spacing-left-overlap);
    grid-row: 2/ 4;
  }
  &__main {
    grid-row: 1/ 3;
  }
  ::v-deep .m-article-wrapper-overlap__main-content {
    height: 100%;
    padding-bottom: 60px;
  }
}
@include media-breakpoint-up(md) {
  .m-article-wrapper-overlap {
    &.right {
      .m-article-wrapper-overlap {
        &__main {
          grid-row: 1/ -1;
          // grid-column: 1 / span 14;
        }
        &__overlay {
          grid-row: 2;
          // grid-column: 14 / span 6;
          align-self: center;
        }
        &__main-content {
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>
